import React from 'react';
import { View } from 'react-native';
import Header from './Header';
import NavFooter from './NavFooter';
import PropTypes from 'prop-types';

export const NativeSiteWrapper = props => {
    return (
        <View style={{ flex: 1 }} testID='NativeSiteWrapper'>
            <Header topNav={props.topNav} />
            {props.children}
            <NavFooter bottomNav={props.bottomNav} />
        </View>
    );
};

NativeSiteWrapper.propTypes = {
    bottomNav: PropTypes.object.isRequired,
    topNav: PropTypes.object.isRequired
};
